import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';
import {
    FIELD_STARTDATE,
    FIELD_ENDDATE,
    FIELD_PROPOSAL_IDS,
    FIELD_PAGE_SIZE,
    FIELD_PAGE_NUM,
    FIELD_USER_CODE,
    PROPOSAL_TABLE,
    EMPTY_COUNT
} from "../../../../utils/constants";
import { setPage } from "../../BPOrder/state/actions";
import $ from 'jquery';
import { ROOT_URL } from "../../../../routes/constants";

const fetchDefault = (iPageSize, iPageNum) => (dispatch) => {

    dispatch(Actions.changeRowSize(iPageSize));
    dispatch(setPage(iPageNum, `${ROOT_URL}/Proposals`));
    
    let params = new URLSearchParams();

    params.append(FIELD_PAGE_SIZE, iPageSize);
    params.append(FIELD_PAGE_NUM, iPageNum);

    ApiService.get(Path.PROPOSAL_GET_LIST, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
            $("."+PROPOSAL_TABLE).scrollTop(EMPTY_COUNT);
        }).catch(()=>{
            dispatch(Actions.setList([])); 
        })
};

const updateBulkPeriod = (proposalIds, startDate, endDate, userCode) => () => {
    let params = new URLSearchParams();
    let strProposalIds = []; 

    proposalIds.map((id)=>strProposalIds.push(`'${id}'`))

    params.append(FIELD_PROPOSAL_IDS, strProposalIds);
    params.append(FIELD_STARTDATE, startDate);
    params.append(FIELD_ENDDATE, endDate);
    params.append(FIELD_USER_CODE, userCode);

    return ApiService.post(Path.PROPOSAL_UPDATE_PERIOD, params)
        .then((response) => {
            return response.data;
        })
};

const addProposal = (payload) => () => {
    return ApiService.add(Path.PROPOSAL_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const editProposal = (payload) => () => {
    return ApiService.update(Path.PROPOSAL_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const viewProposal = (payload) => () => {
    return ApiService.view(Path.PROPOSAL_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const deleteProposal = (id) => () => {
    return ApiService.delete(Path.PROPOSAL_GET_LIST, id)
        .then((response) => {
            return response.data;
        })
};

const insertProduct = (payload, userCode) => () => {
    return ApiService.post(Path.PROPOSAL_INSERT_PRODUCT + "/" + userCode, payload)
        .then((response) => {
            return response.data;
        })
}

const updateProducts = (payload, userCode) => () => {
    return ApiService.post(Path.PROPOSAL_UPDATE_PRODUCT + "/" + userCode, payload)
        .then((response) => {
            return response.data;
        })
}

const deleteProduct = (payload) => () => {
    return ApiService.deleteByKey(Path.PROPOSAL_GET_LIST + "/product", payload)
        .then((response) => {
            return response.data;
        })
};

const deletePartner = (payload) => () => {
    return ApiService.deleteByKey(Path.PROPOSAL_GET_LIST + "/partner", payload)
        .then((response) => {
            return response.data;
        })
};

const checkDateConflict = (proposalIds, startDate, endDate) => () => {
    let params = new URLSearchParams();

    params.append(FIELD_PROPOSAL_IDS, proposalIds);
    params.append(FIELD_STARTDATE, startDate);
    params.append(FIELD_ENDDATE, endDate);

    return ApiService.post(Path.PROPOSAL_CHECK_CONFLICT, params)
        .then((response) => {
            return response.data;
        })
};

const checkPartnerConflict = (mainNumber, branchNumber, startDate, endDate) => () => {
    let params = new URLSearchParams();

    params.append("mainNumber", mainNumber);
    params.append("branchNumber", branchNumber);
    params.append(FIELD_STARTDATE, startDate);
    params.append(FIELD_ENDDATE, endDate);

    return ApiService.post(Path.PROPOSAL_CHECK_PARTNER_CONFLICT, params)
        .then((response) => {
            return response.data;
        })
};

const filterProductList = (payload) => () => {
    return ApiService.post(Path.PROPOSAL_PRODUCTS_FILTER, payload)
        .then((response) => {
            $(".productTable").scrollTop(EMPTY_COUNT);
            return response.data;
        })
};

const filterPartnerList = (payload) => () => {
    return ApiService.post(Path.PROPOSAL_PARTNER_FILTER, payload)
        .then((response) => {
            $(".partnerTable").scrollTop(EMPTY_COUNT);
            return response.data;
        })
};

const insertPartner = (payload, userCode) => () => {
    return ApiService.post(Path.PROPOSAL_INSERT_PARTNER + "/" + userCode, payload)
        .then((response) => {
            return response.data;
        })
}

export {
    fetchDefault,
    updateBulkPeriod,
    addProposal,
    viewProposal,
    editProposal,
    deleteProposal,
    updateProducts,
    deleteProduct,
    deletePartner,
    checkDateConflict,
    filterProductList,
    insertProduct,
    filterPartnerList,
    insertPartner,
    checkPartnerConflict
};
